import { render, staticRenderFns } from "./WebLinksViewer.vue?vue&type=template&id=68f979eb&scoped=true&lang=pug"
import script from "./WebLinksViewer.vue?vue&type=script&lang=js"
export * from "./WebLinksViewer.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "68f979eb",
  null
  
)

export default component.exports